import { fieldRef, op } from './astHelpers';

/** Sum of fields: SUM(f1, f2, ...) */
export const buildSumFormula = (cfg = {}) => {
  const codes = Array.isArray(cfg.sumFieldCodes) ? cfg.sumFieldCodes.filter(Boolean) : [];
  if (!codes.length) return null;
  return op('SUM', codes.map(fieldRef));
};
